// schema
import * as ISchema from "@schema";
// libraries
import React from "react";

// components
import { TeamSections } from "../web-settings";

import { TeamSettingsSearch } from "@components/teams-settings/team-settings-search";

// util
import { getCurrentWorkingGroup } from "@util/working-group.util";
import { augmentTeamMembers } from "@util/team.util";

// state

// material-ui
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

// ~-~-~-~-~-~-~-
// Team Members Settings
// ~-~-~-~-~-~-~-
interface TeamMembersProps {
  viewer: ISchema.IViewer;
  org: ISchema.IOrg;
  team: ISchema.ITeam;
}

const useStyles = makeStyles({
  content: {
    marginBottom: 30,
  },
});

export const TeamMembers = (props: TeamMembersProps) => {
  const classes = useStyles();

  const [locallyInvitedMembers, setLocallyInvitedMembers] = React.useState<
    Record<string, { invited: boolean; person: ISchema.IOrgPerson }>
  >({});

  // ~-~-~-~-~-~-~-
  // Helpers
  // ~-~-~-~-~-~-~-
  const onInvitedMembersChange = (
    locallyInvitedMembers: Record<string, { invited: boolean; person: ISchema.IOrgPerson }>,
  ) => {
    setLocallyInvitedMembers(locallyInvitedMembers);
  };

  // ~-~-~-~-~-~-~-
  // Render
  // ~-~-~-~-~-~-~-
  const { viewer, org, team } = props;

  const workingGroup = getCurrentWorkingGroup(org);
  const suggestedCalendarIds = (workingGroup && workingGroup.calendarIds) || [];

  return (
    <div cw-id={`web-settings-${TeamSections.Members}`} className={classes.content}>
      <Typography variant="h3" className="cw-mb-4">
        Members
      </Typography>
      <TeamSettingsSearch
        viewer={viewer}
        org={org}
        team={team}
        defaultMembers={augmentTeamMembers(
          team.teamMembers,
          suggestedCalendarIds,
          locallyInvitedMembers,
        )}
        // refetchTeams={this.props.refetchTeams}
        invitedMembers={locallyInvitedMembers}
        onInvitedMembersChange={onInvitedMembersChange}
      />
    </div>
  );
};
